import React from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/98TDyinpFrqs6MZWeZaun2/LOGO2.png';
export function Footer() {
  return <footer className="bg-[#050505] text-brand-muted py-16 border-t border-brand-border" data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-103">
          <div className="mb-6 md:mb-0" data-id="element-104">
            <img src={LOGO_URL} alt="Lima Dental Group" className="h-8 w-auto opacity-70" data-id="element-105" />
          </div>

          <div className="text-sm text-center md:text-right font-light space-y-1" data-id="element-106">
            <p data-id="element-107">15600 NW 67th Ave #106, Miami Lakes, FL 33014</p>
            <p data-id="element-108">
              &copy; {new Date().getFullYear()} Lima Dental Group. All rights
              reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}